import DimensionsPage from './DimensionsPage';

export default DimensionsPage;
